import { createThemeCompiler } from '../../../utils';

export const ratingThemeCompiler = createThemeCompiler(({ palette, gap }) => ({
    rating: {
        colors: {
            ratingBorder: palette.themePrimary,
            ratingFill: palette.themePrimary
        },
        composites: {
            gap: gap.none,
            iconSize: {
                xsmall: '12',
                small: '16',
                medium: '24',
                large: '32'
            }
        }
    }
}));
